import * as types from './mutation-types'

const actions = {
  setPlant: async ({ commit }, plant) => {
    commit(types.SET_PLANT, plant)
  }
}
export default actions
